export const CANCELLED = 'anulowano';
export const WAITING = 'oczekiwanie na akceptację';
export const ACCEPTED = 'zaakceptowano / w realizacji';
export const IMPLEMENTED = 'zrealizowano';